import { render, staticRenderFns } from "./JeitoHeptaView.vue?vue&type=template&id=ddbdfd8c&scoped=true"
import script from "./JeitoHeptaView.vue?vue&type=script&lang=js"
export * from "./JeitoHeptaView.vue?vue&type=script&lang=js"
import style0 from "./JeitoHeptaView.vue?vue&type=style&index=0&id=ddbdfd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbdfd8c",
  null
  
)

export default component.exports